import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vendors: [],
  loading: false,
  error: null,
  success: false,
};

const vendorSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    // Get all vendors
    getVendorsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getVendorsSuccess(state, action) {
      state.loading = false;
      state.vendors = action.payload;
      state.success = true;
    },
    getVendorsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Create vendor
    createVendorStart(state) {
      state.loading = true;
      state.error = null;
    },
    createVendorSuccess(state, action) {
      state.loading = false;
      state.vendors.push(action.payload);
      state.success = true;
    },
    createVendorFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Update vendor
    updateVendorStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateVendorSuccess(state, action) {
      state.loading = false;
      state.vendors = state.vendors.map(vendor => 
        vendor._id === action.payload._id ? action.payload : vendor
      );
      state.success = true;
    },
    updateVendorFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Update vendor approval
    updateVendorApprovalStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateVendorApprovalSuccess(state, action) {
      state.loading = false;
      state.vendors = state.vendors.map(vendor => 
        vendor._id === action.payload._id ? action.payload : vendor
      );
      state.success = true;
    },
    updateVendorApprovalFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    
    // Reset state
    resetVendorState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  }
});

export const {
  getVendorsStart,
  getVendorsSuccess,
  getVendorsFailure,
  createVendorStart,
  createVendorSuccess,
  createVendorFailure,
  updateVendorStart,
  updateVendorSuccess,
  updateVendorFailure,
  updateVendorApprovalStart,
  updateVendorApprovalSuccess,
  updateVendorApprovalFailure,
  resetVendorState
} = vendorSlice.actions;

export default vendorSlice.reducer;